import { useNavigate } from "react-router-dom";
import useAppDispatch from "@/hooks/useAppDispatch";
import { handleApiError } from "@/helpers/apiErrorHelper";
import useCart from "@/features/cart/useCart";

//#region Type
interface CartPageViewModel {
  cart: ReturnType<typeof useCart>;

  isPageInitialized: boolean;
  handleCheckoutClick: () => void;
}
//#endregion

const useCartPage = (): CartPageViewModel => {
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const cart = useCart();

  const handleCheckoutClick = async () => {
    if (!cart) return;
    appDispatch.setPageLoading(true);

    try {
      const isCartValid = await cart.canCheckoutCart();
      if (isCartValid) {
        navigate("/checkout");
      } else {
        appDispatch.pushAlert({
          type: "error",
          title: "購物車中的商品可能缺貨或其他錯誤，請檢查購物車錯誤提示後再操作一次",
        });
      }
    } catch (error) {
      handleApiError(error, appDispatch, "驗證購物車失敗，請稍後再試");
    } finally {
      appDispatch.setPageLoading(false);
    }
  };

  return {
    cart,

    isPageInitialized: cart.isCartInitialized,
    handleCheckoutClick,
  };
};

export default useCartPage;
